import {
  ExtendedCriterion,
  useForm,
  useCriteriaCountByState,
  useParticipantFieldsByName,
  useRecruitment,
} from '@app/api';
import { useMemo } from 'react';
import { useProcessedCriteria } from './useRecruitmentQuotas';

export const useApplicationExtendedCriterion = (
  recruitmentId: string | undefined,
  criteriaRefs: string[] | undefined,
): ExtendedCriterion[] => {
  const { data: recruitment } = useRecruitment(recruitmentId);
  const { data: form } = useForm(recruitment?.screeningFormId);
  const { data: criteriaCountByState } = useCriteriaCountByState(
    recruitment?.id,
  );
  const participantFields = useParticipantFieldsByName();

  const relevantCriteriaWithQuota = useMemo(() => {
    if (!recruitment?.criteria || criteriaRefs?.length === 0) {
      return [];
    }

    const criteriaRefsSet = new Set(criteriaRefs);
    return recruitment.criteria.filter((criterion) =>
      criteriaRefsSet.has(criterion.fieldRef),
    );
  }, [recruitment?.criteria, criteriaRefs]);

  return useProcessedCriteria({
    criteria: relevantCriteriaWithQuota,
    participantFields,
    formFields: form?.fields,
    criteriaCountByState: criteriaCountByState,
  });
};
